module.exports = __webpack_public_path__ + "media/images/contact/rincon-9ed35f2f96713f66154e13ad373432d0.jpg";